import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import AIAdvisor from '@/components/AIAdvisor.vue'

// 路由配置
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/ai-advisor'
  },
  {
    path: '/ai-advisor',
    name: 'AI水质顾问',
    component: AIAdvisor
  },
  {
    path: '/water-change',
    name: '水体管理',
    component: () => import('@/components/WaterManagementCalculator.vue')
  },
  {
    path: '/elements',
    name: '元素补充计算',
    component: () => import('@/components/ElementsCalculator.vue')
  },
  {
    path: '/nutrients',
    name: '营养盐控制',
    component: () => import('@/components/NutrientsCalculator.vue')
  },
  {
    path: '/feeding',
    name: '喂食剂量',
    component: () => import('@/components/FeedingCalculator.vue')
  },
  {
    path: '/tank-log',
    name: '鱼缸状态日志',
    component: () => import('@/components/TankLog.vue')
  },
  {
    path: '/par-analyzer',
    name: 'PAR分析器',
    component: () => import('@/components/PARAnalyzer.vue')
  },
  {
    path: '/quarantine',
    name: '检疫追踪',
    component: () => import('@/components/QuarantineTracker.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router